var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_33",
    transform: "translate(0.0238095) scale(0.010582 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_33",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADc0lEQVR4nO2czUtUURiHH5OyhUYFQWCQUJmU1bIWUQRZhBFFUFC0aNHHIvqDImgRYhC0yiiiRWUftkgLDTGCgoIilXIMrFBbnJGGGmfO3HPuec+98z7wMozOeefnw/XOnXPuvaAoiqIoiqL85QBwFRgFpoFvwDBwHegGGuSi5YPNwCNgvkoNAB1CGTPPXmCS6pIXqgDsEUmaYdqpTfJCTQGbBPJmFpvdxWL1WCBvJukiueSF2h88dRWWSAcowwkPPU576JF7RnHfokeDp84gU7iL/h48dRVi3HXMe+gx46GHV2IU/dFDjwkPPbwSo+hnHno88NAj9xzEfR/dFTx1BmkAhkgu+SU6yWRNN8lFHxLIm2luUbvkmyJJM85GYBZ7ybPABpGkOeAL9qI/C2W0wteHRhNwATgFdGK2rvfACPAasxoyDHzA/gvJWswxdaPl62eBddgLbwDWF/N2AtuBrUBb8T2HgR7gCvDTsmfFN3OlFegDdli8dgYYA97+8zgGfC15XTNwA/OhWAt9wEngR8nP1mDmt9sxc9Wlj8steg4Bh4FPNWbxShNuh2KlNYlZkroPjDv0GS/2GCDZ4kG5Giz+rWJcLhMqr3XJk7NEDCwSKo/lNDXguo8uYPan9cA00JJ0sKvoecfxWSOxrxhn73KJig6Eig6Eig6Eig6Eig6Eig6Eig6Eig6Eig6Eig6Eig6Eig6Eq+jfXlLUAa6i31T43TxwD7iIubpqdbE6gLOY5SbFkmPAHP+vRtwGtlmM341ZmJVePbEtUY4AzzELof3F57XQgtvFQXUj2gfN+LmkQkVbsJPyu6GYKjf0IS8zFdGxHUf3SgdIi9hED0oHSIvYRPu4UChKYhOdqw+cUmIT3SYdIC1iE71LOkBaxCb6jHSAemAf+oUldVYC75AXGbXoo5jzpCdINqm0CniBvMSoRR+n/L/7HeyuaekiG1uyuOhXFULNAXeBc8AWzHToCswVUOeBhxXGxlqJcT0R/Rew1LFHlkjsS8/4rw094z92VHQgVHQgVHQgVHQgXEXX21FHYlxFT3lJUQe4iha9tUJgCi6DXUX3O47PEiMug11FX3McnyV6pAP0Ij/Zk3YNAst8CUtKC+YWldIy0pTc6s2WI42Y6dAn+LktsXQVgKeYu86Ib8mKoiiKoiiKoiiKoiix8QdYWgf+M7NlwAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.cba71a0e3dbd974305cadec02dba1ca5.svg";
export { ForwardRef as ReactComponent };